import * as React from 'react'

const IconNativeAds = (isActive?, className?: string) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             className={className ? className : ''} width="37" height="70" viewBox="0 0 37 70">
            <g fill="none" fillRule="evenodd" stroke={isActive ? '#ff6262' : '#4A4A83'} strokeWidth=".66">
                <path d="M34.025 17.262c0-1.073-.654-2.32-1.458-2.785L8.387.505C7.585.04 6.932.534 6.932 1.606v9.968c0 1.072.653 2.32 1.457 2.784l24.18 13.972c.803.465 1.457-.029 1.457-1.101v-9.967zM34.025 57.448c0-1.072-.654-2.32-1.458-2.785L8.387 40.692c-.803-.465-1.456.028-1.456 1.101v9.967c0 1.072.653 2.32 1.457 2.784l24.18 13.973c.803.464 1.457-.029 1.457-1.102v-9.967zM.919 19.724a65.513 65.513 0 0 1 2.25-1.3c.31-.161.708-.137 1.141.113L34.1 35.75c.99.572 1.794 2.11 1.794 3.43v12.28c0 .743-.254 1.26-.653 1.469-.31.162-1.76.995-2.12 1.224-.32.202-.743.193-1.207-.075L2.124 36.866c-.99-.572-1.794-2.11-1.794-3.43v-12.28c0-.702.227-1.203.589-1.432z"/>
                <path d="M33.708 40.443c0-1.321-.803-2.858-1.794-3.43L2.124 19.798c-.99-.573-1.794.036-1.794 1.357v12.28c0 1.32.804 2.858 1.794 3.43l29.79 17.213c.99.573 1.794-.036 1.794-1.357V40.443z"/>
                <path d="M12.316 30.376c0-.828-.503-1.791-1.124-2.15l-7.01-4.05c-.62-.358-1.124.023-1.124.85v7.694c0 .827.504 1.79 1.125 2.149l7.01 4.05c.62.359 1.123-.022 1.123-.85v-7.693zM16.566 34.867l11.915 6.88M16.566 38.488l5.958 3.44"/>
            </g>
        </svg>
    )
}

export default IconNativeAds


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/svg/iconNativeAds.tsx